import React, { useState } from 'react'
import { useSearchParams } from 'react-router-dom'

import reactQuery from '../../_helpers/reactQuery'
import stringUtils from '../../_helpers/stringUtils'
import { orderService, userService } from '../../_services'
import { types } from '../../constants'
import translate from '../../locales/en'
import Document from '../Abstract/Document'

const Order = function () {
  const collectionName = 'Orders'
  const singleCollectionName = 'Order'
  const queryKey = collectionName.toLowerCase()
  const [body, setBody] = useState({})
  const defaultQueryParams = {}
  const [queryParams, setQueryParams] = useState(defaultQueryParams)
  const getQuery = reactQuery.getQuery(
    queryKey,
    queryParams,
    orderService.query
  )
  const [searchParams, setSearchParams] = useSearchParams()
  return (
    <Document
      tableActions={[
        {
          buttonLabel: translate.Filters,
          buttonColor: 'primary',
          onSubmit: (args) =>
            setSearchParams({
              ...Object.fromEntries([...searchParams]),
              ...args,
              query: collectionName,
            }),
          body,
          setBody,
          withClear: true,
          clearFunction: () => setBody({}),
          withForm: true,
          form: {
            title: `${translate.Filter} ${translate[singleCollectionName]}`,
            inputs: [
              {
                name: 'userName',
                label: 'User Name',
                type: 'autocomplete',
                queryKey: 'users',
                getApi: userService.query,
                keys: { _id: 'userId', name: 'userName' },
                options: { role: 'user' },
                value: {
                  userId: queryParams.userId || '',
                  userName: queryParams.userName || '',
                },
              },
              {
                name: 'status',
                label: 'Status',
                type: 'select',
                options: ['', ...types.orderTypes].map((orderType) => ({
                  label: stringUtils.camelCase(orderType),
                  value: orderType,
                })),
                value: queryParams.status,
              },
            ],
          },
          withReset: true,
          resetFunction: () => setSearchParams(),
        },
      ]}
      title={collectionName}
      getQuery={getQuery}
      queryKey={queryKey}
      defaultQueryParams={defaultQueryParams}
      queryParams={queryParams}
      setQueryParams={setQueryParams}
      many
    />
  )
}
export default Order
